import { Injectable } from '@angular/core';

import { L10n, Wrapper } from '@skylab-angular-shared/core';
import { AccountancyPeriodDescriptorBase } from '@skylab-shared/business';

export { AccountancyPeriodDescriptorBase };

@Injectable({ providedIn: 'root' })
@Wrapper(AccountancyPeriodDescriptorBase)
export class AccountancyPeriodDescriptor {
    public constructor(
        l10n: L10n
    ) { }
}
